import { useHotkeys, type Options } from 'react-hotkeys-hook';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import type { HotkeyId } from '@/lib/hotkeys/registry';

/**
 * Bind a handler to a user-configurable global shortcut. Resolves the
 * current combo from stored preferences (falling back to the registry
 * default) and re-binds when the preference changes.
 */
export function useConfigurableHotkey(
  id: HotkeyId,
  handler: (event: KeyboardEvent) => void,
  options?: Options,
  deps: unknown[] = [],
) {
  const { getKeys } = useKeyboardShortcuts();
  const keys = getKeys(id);

  useHotkeys(keys, handler, options, [keys, ...deps]);
}
